const getCaptchaSessionFromToken = (token: string | null): string => token?.split('|')?.[0] ?? '';

export default getCaptchaSessionFromToken;
